export function toTwoDimensionalArray<T>(array: T[], columns: number) {
  return array.reduce((accumulator, current, index) => {
    const colIndex = Math.floor(index / columns)
    if (accumulator[colIndex] === undefined) {
      accumulator.push([])
    }
    accumulator[colIndex].push(current)
    return accumulator
  }, [] as T[][])
}

export function sortByKeyLocale<T extends Record<string, unknown>>(arr: T[], key: keyof T, locale: string): T[] {
  const arrCopy = arr.slice()
  return arrCopy.sort((a, b) => {
    const aString = String(a[key])
    const bString = String(b[key])
    return aString.localeCompare(bString, locale, {sensitivity: 'base'})
  })
}
